import * as Sentry from '@sentry/vue';
import { configureVf, createFilters, installVf } from '@zyno-io/vue-foundation';
import { type App } from 'vue';

import type { hasPermission } from './shared/helpers/permissions.helpers';

import { isMobileBrowser } from './app.mobile';

// configure Vue Foundation
configureVf({
    defaultDateFormat: 'M/d/yy',
    defaultTimeFormat: 'h:mmaaa',
    defaultCurrencyDivisor: 100,

    errorHandler(err) {
        console.error(err);
        Sentry.captureException(err);
    },

    disableStickyMinWidthDirective: isMobileBrowser(),
    unhandledErrorSupportText: 'please contact support@zyno.io or submit a ticket via the Help link'
});

// create base filters + any custom filters
export const filters = createFilters(filters => ({
    dateTimeFriendly(value: string | null, formatStr?: string) {
        if (!value) return '-';
        const now = new Date();
        const dt = new Date(value);
        if (dt.getMonth() === now.getMonth() && dt.getFullYear() === now.getFullYear() && dt.getDate() === now.getDate()) {
            return `Today ${filters.time(value)}`;
        } else {
            return filters.dateTime(value, formatStr);
        }
    }
}));

// attach filters to Vue
declare module 'vue' {
    export interface ComponentCustomProperties {
        $filters: typeof filters;
        $hp: typeof hasPermission;
    }
}

// global Vue Foundation setup helper
export function setupVf(app: App, injectables?: { $hp: typeof hasPermission }) {
    installVf(app);
    app.config.globalProperties.$filters = filters;

    if (injectables) {
        app.config.globalProperties.$hp = injectables.$hp;
    }
}
